import { Box,  Typography } from "@mui/material"

export const CustomBadge = ({ icon, bgcolor, padding, text, textcolor ,onClick }) => {
    return (
        <Box 

        onClick={onClick}
            sx={{
                backgroundColor: bgcolor || "blue.light",
                borderRadius: "5px",
                p: padding || "5px 10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent:"center",
                // gap:text ?? 2

            }}
        >
            {icon}
            <Typography variant="body2" color={textcolor}> {text}</Typography>

        </Box>
    )
}

